$(document).on('click', '.plp--atb-trigger:not(.js-product-add-to-cart-plp):not(.plp-final-sale-options-trigger):not(.item-in-cart)', function(){
    var $this = $(this);
    
    $this.parents('.plp--atb').find('.plp-atb--buttons').addClass('plp-atb--show-options');
    $this.parents('.card-wrapper').addClass('card-showing-atb');
  
    $this.parents('.collection-grid-product-item').addClass('plp-atb--active');
  
});

$(document).on('click', '.plp-final-sale-options-trigger:not(.item-in-cart)', function(){
    var $this = $(this);
    
    $this.parents('.plp--atb').find('.plp-atb--buttons').addClass('plp-atb--show-final-sale-options');
  
});


window.addEventListener('scroll', function(){
    $('.plp-atb--buttons').removeClass('plp-atb--show-options');
    $('.card-showing-atb').removeClass('card-showing-atb');
}, true)

// On Scroll hide active bag
  
$(document).mouseup(function (e) {
    
    var container = $(".plp-atb--active");
    if(!container.is(e.target) && 
    container.has(e.target).length === 0) {
        
          $('.card-showing-atb .plp-atb--buttons').removeClass('plp-atb--show-options');

          $('.card-showing-atb').removeClass('card-showing-atb');
          
          
  
    }

});

$(document).on('click', 'button.btn.btn-solid.plp-trigger-inner-options', function(){
    var $this = $(this);
    $this.parents('.plp-atb--buttons').find('.plp-atb--buttons-inner').addClass('plp-atb--show--inner-options');
    $this.parents('.plp-atb--buttons').addClass('plp-atb--show--inner-options-final-sale');
    $('body').addClass('body-plp-atb--show--inner-options');
  });